<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        <v-col v-if="validateLoad==true" id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <v-row justify="center" align="center">
                <v-col calign-self="center" cols="auto">
                    <v-row justify="center" >
                        <v-progress-circular
                        :size="70"
                        :width="7"
                        :color="$store.state.colors.primary"
                        indeterminate
                        ></v-progress-circular>                        
                    </v-row> 
                </v-col>
            </v-row>
        </v-col>         
        <v-col v-else id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <!-- Back button -->
            <v-row justify="start" align="center" style="height:55px; background-color: #e6e6e6;" class="pt-0">
                <v-btn @click="$router.push({ name: 'menu'})" icon  :color="$store.state.colors.primary">
                    <v-icon x-large >mdi-chevron-left</v-icon>
                </v-btn>
            </v-row>
            <v-row justify="center" align="center" style="color: white">
                <v-col calign-self="center" cols="auto">
                    <v-row justify="center" >
                        <v-img src="@/assets/resources/yoomi/happy.png" max-width="80px"></v-img>
                    </v-row> 
                    <v-row justify="center" class="pl-2 pb-0 mb-0 pt-4 RestoRegular" style="font-size: 25px;" :style="{ 'color': $store.state.colors.primary }">
                        ¡Gracias {{userName}}!
                    </v-row>  
                    <v-row justify="center" class="pl-2 pb-0 mb-0 pt-4 RestoRegular" style="font-size: 18px;color:#4D4D4D; height:20px;">
                        Tu pedido ya se está 
                    </v-row>
                    <v-row justify="center" class="pl-2 pb-0 mb-0 pt-5 RestoRegular" style="font-size: 18px;color:#4D4D4D; height:20px;">
                        preparando en el restaurante
                    </v-row>
                    <v-row justify="center" class="pl-2 pb-0 mb-2 pt-6 RestoBold" style="font-size: 18px;color:#4D4D4D; height:20px;">
                        {{$route.params.sucursal}}
                    </v-row>
                    <v-row v-if="sucursal.metodo_entrega == 'Entrega a domicilio'" justify="center" class="pl-2 mb-2 pt-6 RestoRegular" style="font-size: 14px;color:#4D4D4D; height:20px; text-align: center">
                         El tiempo de preparación de tu pedido tomará de 40 a 50 minutos.
                    </v-row>
                    <v-row v-else justify="center" class="pl-2 mb-2 pt-6 RestoRegular" style="font-size: 14px;color:#4D4D4D; height:20px; text-align: center">
                         Estará listo a la hora seleccionada: {{$route.params.horario_recoge}} hrs
                    </v-row>
                    <v-row justify="center" class="pl-2 pb-0 mb-0 pt-4 RestoRegular" style="font-size: 20px;color:#4D4D4D; height:20px;">
                    </v-row>
                </v-col>
            </v-row>
            <v-row class="mt-0" justify="center" v-for="(platillo, index) in platillos" :key="index" style="font-size: 12px; border-bottom: 1px solid #424242; background-color: #F0F0F0; width: 95%; margin: 0 auto;">
                                
                <v-col cols="auto" align-self="center">
                     <v-row class="RestoBold" align="center" style="font-size: 13px; background-color: #F0F0F0;">
                        {{platillo.cantidad}}
                    </v-row>                    
                </v-col>
                <v-col cols="5" align-self="center" class="ml-2">
                     <v-row class="RestoBold"  style="font-size: 13px; color: #424242; height: 100%" justify="start" align="center">
                        {{platillo.titulo_platillo}}
                    </v-row>
                    <v-row v-for="(modificador, index) in platillo.modificadores" :key="index">
                         <p v-if="modificador.cantidad != null && modificador.cantidad != 0" class="py-0 my-0">   {{modificador.nombre}} x{{modificador.cantidad}} </p>
                    </v-row>
                    <v-row class="mt-2">
                    </v-row>
                    <v-row v-for="(adicional, index) in platillo.adicionales" :key="index" >
                        <p v-if="adicional.cantidad != null && adicional.cantidad != 0" class="py-0 my-0">{{adicional.nombre}} x{{adicional.cantidad}}</p>
                    </v-row>
                </v-col>
            </v-row>
            <v-row justify="center" align="center">
                <v-col calign-self="center" cols="auto">
                    <v-row v-if="sucursal.metodo_entrega == 'Entrega a domicilio'" justify="center" class="pl-0 pb-0 mb-0 pt-0 RestoRegular" style="font-size: 18px;" :style="{ 'color': $store.state.colors.primary }">
                        Se entrega en:
                    </v-row>
                    <v-row v-else justify="center" class="pl-0 pb-0 mb-0 pt-0 RestoRegular" style="font-size: 18px;" :style="{ 'color': $store.state.colors.primary }">
                        Lo recoges en:
                    </v-row>
                </v-col>
            </v-row>
            <v-row v-if="sucursal.metodo_entrega == 'Entrega a domicilio'" justify="center" align="center" style="font-size: 12px; background-color: #F0F0F0; width: 95%; margin: 0 auto;">
                <v-col calign-self="center" cols="auto">
                    <v-row justify="center" >
                        <v-img  src="@/assets/resources/user/casa.svg" max-width="20px"></v-img>
                    </v-row>
                    <v-row justify="center" class="pb-0 mb-0 pt-2 RestoRegular" style="font-size: 13px;color:#424242;">
                        {{address.calle}} #{{address.num_exterior}} {{address.colonia}} 
                    </v-row>
                    <v-row justify="center" class="pb-0 mb-0 pt-2 RestoBold" style="font-size: 13px;color:#4D4D4D;">
                        {{date}} 
                    </v-row>
                    <v-row justify="center" class="pb-0 mb-0 pt-2 RestoRegular" style="font-size: 13px;color:#4D4D4D;">
                        No. de Pedido <span class="RestoBold ml-1"> {{$route.params.id_pedido}} </span>
                    </v-row>
                </v-col>
            </v-row>

            <v-row v-else justify="center" align="center" style="font-size: 12px; background-color: #F0F0F0; width: 95%; margin: 0 auto;">
                <v-col calign-self="center" cols="auto">
                    <v-row justify="center" >
                        <v-img src="@/assets/resources/user/restaurante.svg" max-width="20px"></v-img>
                    </v-row>
                    <v-row justify="center" class="pb-0 mb-0 pt-2 RestoRegular" style="font-size: 13px;color:#424242;">
                        {{sucursal.calle}} #{{sucursal.num_exterior}}, {{sucursal.ciudad}} 
                    </v-row>
                    <v-row justify="center" class="pb-0 mb-0 pt-0 RestoRegular" style="font-size: 13px;color:#424242;">
                        Teléfono: {{sucursal.telefono_sucursal}} 
                    </v-row>
                    <v-row justify="center" class="pb-0 mb-0 pt-2 RestoBold" style="font-size: 13px;color:#4D4D4D;">
                        {{date}} 
                    </v-row>
                    <v-row justify="center" class="pb-0 mb-0 pt-2 RestoRegular" style="font-size: 13px;color:#4D4D4D;">
                        No. de Pedido <span class="RestoBold ml-1"> {{$route.params.id_pedido}} </span>
                    </v-row>
                </v-col>
            </v-row>
            <v-row justify="center" class="mt-4">
                <v-col >
                    <v-row justify="end"  class="mr-1">
                        <v-btn @click="getFactura" :disabled="factura" :loading="loading" :color="$store.state.colors.secondary" style="color: white" class="buttonLower">
                            Requiero factura
                        </v-btn>
                    </v-row> 
                </v-col>
                <v-col >
                    <v-row justify="start" class="ml-1">
                        <v-btn @click="$router.push({ name: 'menu'})" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                            Finalizar
                        </v-btn>
                    </v-row> 
                </v-col>
            </v-row>
        </v-col>
        <v-dialog v-model="dialogS" max-width="400" persistent>
            <v-card>
                <v-row justify="center" align="center" style="color: white">
                    <v-col cols="auto">
                        
                        <v-row justify="center" class="pb-0 mb-0 pt-4 RestoRegular" style="font-size: 18px;color:#4D4D4D; line-height: 23px">
                            Hemos recibido tu mensaje, te
                        </v-row>
                        <v-row justify="center" class="py-0 my-0 RestoRegular" style="font-size: 18px;color:#4D4D4D; line-height: 23px">
                            contactaremos por correo electrónico
                        </v-row>
                        <v-row justify="center" class="pb-0 mb-0  RestoRegular" style="font-size: 18px;color:#4D4D4D; line-height: 23px">
                            para la generación de tu factura.
                        </v-row>
                    </v-col>
                </v-row>
                <v-row justify="center" class="mt-0">
                    <v-col calign-self="center" class="mt-0 pt-0" cols="auto">
                        <v-row justify="center" class="mt-0 pt-0">
                            <v-btn @click="dialogS = false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                                Entendido
                            </v-btn>
                        </v-row> 
                    </v-col>                      
                </v-row>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogF" max-width="400" persistent>
            <v-card>
                <v-row justify="center" align="center" style="color: white">
                    <v-col cols="auto">
                        
                        <v-row justify="center" class="pb-0 mb-0 pt-4 RestoRegular" style="font-size: 18px;color:#4D4D4D; line-height: 23px">
                            No pudimos procesar tu solicitud,
                        </v-row>
                        <v-row justify="center" class="py-0 my-0 RestoRegular" style="font-size: 18px;color:#4D4D4D; line-height: 23px">
                            por favor contacta directamente
                        </v-row>
                        <v-row justify="center" class="py-0 my-0 RestoRegular" style="font-size: 18px;color:#4D4D4D; line-height: 23px">
                            a la sucursal
                        </v-row>
                    </v-col>
                </v-row>
                <v-row justify="center" class="mt-0">
                    <v-col calign-self="center" class="mt-0 pt-0" cols="auto">
                        <v-row justify="center" class="mt-0 pt-0">
                            <v-btn @click="dialogF = false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                                Entendido
                            </v-btn>
                        </v-row> 
                    </v-col>                      
                </v-row>
            </v-card>
        </v-dialog>
    </v-row>
</template>


<script>
import axios from 'axios';
export default {
    data() {
        return {
            loading: false,
            dialogS: false,
            dialogF: false,
            factura: false,
            sucursal: {},
            userName: localStorage.getItem("nombre_cliente"),
            alert:false,
            idOrder:null,
            addresses: null,
            active: null,
            platillos: null,
            image: null,
            order: JSON.parse(localStorage.getItem("Orden")),
            address:JSON.parse(localStorage.getItem("addressUser")),
            validateLoad:true,
            date:null,
        }
    },
    created() {
        console.log(this.$store.state.finishedData)
        this.sucursal = this.$store.state.finishedData;
        this.platillos=this.order.platillos;
        this.idOrder=this.$route.params.id;
        this.$store.state.hideFooter = false;
        // console.log("EL OBJETO PLATILLO: ",this.platillos);
        var f = new Date();
        this.date = f.getDate() + "/" + (f.getMonth() +1) + "/" + f.getFullYear();
        this.validateLoad=false;
    },
    watch:{

    },
    methods: {
        getFactura() {
            this.factura = true;
            this.loading = true;
            var body = {
                id_pedido: this.$route.params.id_pedido,
                id_sucursal: localStorage.getItem("id_sucursal")
            }
            axios.post('/requiere_factura', body, { headers: { Authorization: localStorage.getItem("token") }, timeout: 60000 } )
            .then(res =>{
                console.log(res);
                if(res.data.mensaje == "Factura requerida al admin de suc")
                {
                    this.dialogS = true;
                    this.loading = false
                }
                else{
                    this.dialogF = true;
                    this.loading = false
                } 
            })
            .catch(error => {
                console.log(error);
                this.loading = false
                this.dialogF = true;
                });
        },
        add(index){
            this.platillos[index].cantidad++;
        },
        minus(index){
            if(this.platillos[index].cantidad > 1)
                this.platillos[index].cantidad--;
        },
    }
}
</script>

<style scoped>
    .rounded-btn{
       border-radius:20px;
    }

    .hidscroll {
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .active {
        color: white;
    }
</style>